import*as e from"react";var r=!!e.useInsertionEffect&&e.useInsertionEffect||function(e){return e()};export{r as useInsertionEffectAlwaysWithSyncFallback};
//# sourceMappingURL=emotion-use-insertion-effect-with-fallbacks.browser.esm.js.map
